import React from 'react'
import * as Icon from 'react-icons/fi'
import { Checkbox } from 'bootflex'
import { FaTimes } from 'react-icons/fa'

const MyComponent = () => {
  return (
    <div className='p-4'>
      <h4>Default:</h4>
      <Checkbox />
      <h4>Default Dot</h4>
      <Checkbox dot checked />
      <Checkbox label='Custom Icon Red Background' checked bg='red' icon={<FaTimes size='0.75em' />} />
      <Checkbox
        checked={true}
        icon={
          <div
            style={{
              display: 'flex',
              flex: 1,
              backgroundColor: '#174A41',
              alignSelf: 'stretch',
            }}
          >
            <Icon.FiCheck color='white' size={20} />
          </div>
        }
        borderRadius={20}
        style={{ overflow: 'hidden' }}
        size={20}
        label='Round Checkbox'
      />
    </div>
  )
}

export default MyComponent
